export const TectonicLensAbi = [
  {
    inputs: [
      {
        internalType: 'contract TectonicCoreLensInterface',
        name: 'core',
        type: 'address',
      },
    ],
    name: 'getMarketsData',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'tokenAddress', type: 'address' },
          { internalType: 'string', name: 'label', type: 'string' },
          { internalType: 'string', name: 'symbol', type: 'string' },
          { internalType: 'uint8', name: 'decimal', type: 'uint8' },
          {
            internalType: 'address',
            name: 'ttokenAddress',
            type: 'address',
          },
          { internalType: 'uint8', name: 'ttokenDecimal', type: 'uint8' },
          { internalType: 'uint256', name: 'borrowCap', type: 'uint256' },
          { internalType: 'uint256', name: 'supplyCap', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'availableLiquidity',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'asCollateralEnabled',
            type: 'bool',
          },
          { internalType: 'uint256', name: 'reserves', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'reserveFactor',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'collateralFactor',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'liquidationPenalty',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'price', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'exchangeRate',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'tTokenMinted',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
          { internalType: 'uint256', name: 'totalBorrow', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'borrowRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'availableBorrow',
            type: 'uint256',
          },
          { internalType: 'bool', name: 'isBoosted', type: 'bool' },
          {
            internalType: 'uint256',
            name: 'baseRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'multiplierPerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'jumpMultiplierPerBlock',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'kink', type: 'uint256' },
        ],
        internalType: 'struct TectonicLens.MarketData[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const
